/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatsByCloudAccountWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("ThreatsByCloudAccountWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return ThreatsByCloudAccountWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ThreatsByCloudAccountWidgetConfiguration>): ThreatsByCloudAccountWidgetConfiguration {
        let obj = Object.assign(new ThreatsByCloudAccountWidgetConfiguration(), model);
        ThreatsByCloudAccountWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatsByCloudAccountWidgetConfiguration>): ThreatsByCloudAccountWidgetConfiguration {
        if (!model) return null;
        return ThreatsByCloudAccountWidgetConfiguration.newInstance(<ThreatsByCloudAccountWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatsByCloudAccountWidgetConfiguration) {
        if (!obj) return;

        models.ThreatsByCloudAccountWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatsByCloudAccountWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatsByCloudAccountWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
